<template>
  <div class="feed-back">
    <el-row>
      <el-col :span="4" class="m-label" style="margin-top: .16rem;margin-right: .3rem;">当前考核类型</el-col>
      <el-col :span="7">
        <el-tag v-if="cType === 1" size="mini" style="margin-top: .26rem;">订单沟通</el-tag>
        <el-tag v-if="cType === 11" size="mini" style="margin-top: .1rem;">线索沟通</el-tag>
        <el-tag v-if="cType === 16" size="mini" style="margin-top: .1rem;">公司沟通</el-tag>
        <el-tag v-if="cType === 17" size="mini" style="margin-top: .1rem;">客户沟通</el-tag>
        <el-tag v-if="cType === 18" size="mini" style="margin-top: .1rem;">续费沟通</el-tag>
        <el-tag v-if="cType === 19" size="mini" style="margin-top: .1rem;">订单服务</el-tag>
        <el-tag v-if="cType === 21" size="mini" style="margin-top: .1rem;">待办事项</el-tag>
        <el-tag v-if="cType === 22" size="mini" style="margin-top: .1rem;">快递事项</el-tag>
        <el-tag v-if="cType === 27" size="mini" style="margin-top: .1rem;">退款沟通</el-tag>
        <el-tag v-if="cType === 29" size="mini" style="margin-top: .1rem;">未支付订单沟通</el-tag>
        <el-tag v-if="cType === 39" size="mini" style="margin-top: .1rem;">外部资源外呼</el-tag>
      </el-col>
    </el-row>
    <el-row style="margin-top: .2rem;">
      <el-col :span="4" class="m-label" style="height: 28px;line-height: 28px;margin-right: .3rem;">与客户联系方式</el-col>
      <el-col :span="8" style="float: left !important">
        <el-select v-model="reflectForm.contact_type" filterable placeholder="请选择" clearable size="mini">
          <el-option v-for="item in chat_methods" :key="item.id" :value="item.id"
            :label="item.process_check_name"></el-option>
        </el-select>
      </el-col>
      <!-- <template v-if="isShow === true"> -->
      <el-col :span="3" class="m-label"
        style="height: 28px;line-height: 28px;margin-right: .3rem;position: relative;">客户意向<i class="el-icon-question"
          style="position: absolute;" @click="dialogVisible3 = true"></i></el-col>
      <el-col :span="7" style="float: left !important">
        <el-radio-group v-model="reflectForm.satisfy" size="mini">
          <el-radio-button label="1">A</el-radio-button>
          <el-radio-button label="2">B</el-radio-button>
          <el-radio-button label="3">C</el-radio-button>
          <el-radio-button label="4">D</el-radio-button>
        </el-radio-group>
      </el-col>
      <!-- </template> -->
    </el-row>
    <el-row style="margin-top: .2rem;">
      <el-col :span="4" class="m-label" style="height: 28px;line-height: 28px;margin-right: .3rem;">沟通关键词分类</el-col>
      <el-col :span="19" style="float: left !important">
        <el-radio-group @change="handelKeywordCateChange" class="elRadioGroup" v-model="reflectForm.keyword_cate"
          size="small">
          <el-radio-button v-for="(item, index) in keywordCates" :key="index" :label="item.id">
            {{ item.process_check_name }}
          </el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row style="margin-top: .2rem;">
      <el-col :span="4" class="m-label"
        style="height: 28px;line-height: 18px;margin-right: .3rem;position: relative;">选择沟通关键词
      </el-col>
      <el-col :span="19" style="float: left !important">
        <el-checkbox-group v-model="reflectForm.keyword">
          <el-checkbox v-for="item in childKeywords" :label="item.label" :key="item.value"></el-checkbox>
        </el-checkbox-group>
      </el-col>
    </el-row>
    <el-row style="margin-top: .2rem;">
      <el-col :span="3" class="m-label" style="height: 28px;line-height: 28px;">有效沟通</el-col>
      <el-col :span="6" style="float: left !important">
        <el-radio-group v-model="reflectForm.has_contacted" size="mini">
          <el-radio-button label="1">是</el-radio-button>
          <el-radio-button label="2">否（回访）</el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="3" class="m-label" style="height: 28px;line-height: 28px;position: relative;">
        沟通提醒
      </el-col>
      <el-col :span="5" style="float: left !important">
        <el-radio-group v-model="reflectForm.is_notice" size="mini">
          <el-radio-button label="1">需要</el-radio-button>
          <el-radio-button label="0">不需要</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row style="margin-top: .2rem;" v-show="cType === 17">
      <el-col :span="3" class="m-label" style="height: 28px;line-height: 28px;position: relative;">
        添加微信
      </el-col>
      <el-col :span="5" style="float: left !important">
        <el-radio-group v-model="reflectForm.is_add_wx" size="mini">
          <el-radio-button label="1">是</el-radio-button>
          <el-radio-button label="2">否</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row style="margin-top: .2rem;" v-show="cType === 16">
      <el-col :span="3" class="m-label" style="height: 28px;line-height: 28px;">是否核税</el-col>
      <el-col :span="8" style="float: left !important">
        <el-radio-group v-model="reflectForm.is_check_tax" size="mini">
          <el-radio-button label="1">是</el-radio-button>
          <el-radio-button label="0">否</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row style="margin-top: .2rem;" v-show="reflectForm.is_notice === '1'">
      <el-col :span="4" class="m-label" style="height: 28px;line-height: 28px;margin-right: .3rem;">下次沟通时间</el-col>
      <el-col :span="8" style="float: left !important">
        <el-date-picker size="mini" :value-format="'yyyy-MM-dd HH:mm:ss'" :format="'yyyy-MM-dd HH:mm:ss'"
          type="datetime" v-model="reflectForm.next_contact_time" :picker-options="nextPickerOptions"></el-date-picker>
      </el-col>
    </el-row>
    <el-row v-if="reflectForm.contact_type === 1" class="mt-20">
      <el-col :span="6" class="m-label">通话时长</el-col>
      <el-col :span="10">
        <el-input placeholder="请输入联系内容" v-model="reflectForm.contact_duration" size="mini">
          <template slot="append">秒</template>
        </el-input>
      </el-col>
    </el-row>
    <el-row class="mt-20">
      <el-input type="textarea" placeholder="请输入反馈内容" v-model="reflectForm.content"></el-input>
    </el-row>
    <el-row class="mt-10">
      <el-upload ref="upload" multiple action="#" :headers="uploadHeader" accept="image/png, image/jpeg, image/gif"
        :on-change="fileChange" :on-remove="fileRemove" :auto-upload="false" :file-list="uploadedList"
        list-type="picture">
        <el-link slot="trigger" type="primary">上传图片凭证</el-link>
      </el-upload>
    </el-row>
    <el-row class="mt-10">
      <el-input v-paste="handleParse" type="textarea" placeholder="请点击此处，再粘贴复制的截图" />
    </el-row>
    <el-row class="mt-10" style="display: flex;align-items: center;" v-if="!aleadyHighIntentCustomer">
      <el-col :span="4">
        <span style="font-weight: bold;color: #409EFF;">高意向客户反馈</span>
      </el-col>
      <el-col :span="3">
        <el-checkbox v-model="StrongIntentionCheckBox"></el-checkbox>
      </el-col>
    </el-row>
    <el-row class="mt-10" v-else>
      <span style="font-weight: bold;color: #409EFF;">已是高意向客户</span>
    </el-row>
    <el-row class="mt-10" v-if="StrongIntentionCheckBox">
      <set-as-high-intent-customer ref="setAsHighIntentCustomer" />
    </el-row>
    <el-row class="mt-10 tr">
      <el-button type="primary" size="mini" @click="submitUpload">提交</el-button>
    </el-row>
    <el-divider content-position="left">反馈历史</el-divider>
    <el-row>
      <el-timeline>
        <el-timeline-item v-for="reflect in reflects" :key="reflect.id" :timestamp="reflect.created_at" placement="top">
          <el-card>
            <h5 style="line-height: .4rem;">{{ reflect.executor }} 通过 {{ reflect.contact_type }} 进行联系，
              <span v-if="reflect.contact_duration"> 沟通了 {{ reflect.contact_duration }} 秒，</span>
              是否有效沟通：<span v-if="reflect.is_contacted === 1">是，</span>
              <span v-else-if="reflect.is_contacted === 2">否（回访），</span>
              <!-- <span v-if="isShow === true"> -->
              客户意向：
              <span v-if="reflect.satisfy === 1">A</span>
              <span v-else-if="reflect.satisfy === 2">B</span>
              <span v-else-if="reflect.satisfy === 3">C</span>
              <span v-else-if="reflect.satisfy === 4">D</span>
              <!-- </span> -->
              ，沟通关键词：{{ reflect.keyword }}
              <span v-if="reflect.is_notice === 1">需要提醒，提醒时间：{{ reflect.next_contact_time }}</span>
              <span v-else>，不需要提醒。</span>
            </h5>

            <p>反馈内容：{{ reflect.reflect_content }}</p>
            <ul class="el-upload-list el-upload-list--picture" style="margin-bottom: .2rem;">
              <li class="el-upload-list__item is-success" v-for="image in reflect.images" :key="image.id">
                <img class="el-upload-list__item-thumbnail" :src="image.url">
                <a class="el-upload-list__item-name" @click="handleReflectPreview(image)">{{ image.name }}</a>
              </li>
            </ul>

            <!-- 回复内容 -->
            <el-divider content-position="left">开发建议记录</el-divider>
            <el-timeline>
              <el-timeline-item v-for="item in reflect.reflect_subs" :key="item.id" :timestamp="item.created_at"
                placement="top">
                <p>{{ item.replyer_name }}回复：{{ item.content }}</p>
              </el-timeline-item>
            </el-timeline>
            <el-row v-show="developText">
              <el-input type="textarea" placeholder="回复内容" v-model="develop.content"></el-input>
            </el-row>
            <!-- 开发建议 -->
            <el-row class="mt-10 tr">
              <el-button v-show="developText" type="warning" size="mini" @click="developAdviceCancel">取消</el-button>
              <el-button v-show="developText" type="primary" size="mini"
                @click="developAdviceSave(reflect.id)">保存</el-button>
              <el-button v-show="developText === false" type="primary" size="mini"
                @click="developAdvice">开发建议</el-button>
            </el-row>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-row>
    <el-dialog :visible.sync="dialogVisible3" class="el_dialogs" :append-to-body="true" width="45%">
      <div class="box_title">
        <span>客户意向</span>
        <i style="color: #4C87FC;" class="el-icon-question"></i>
      </div>
      <div class="dialog_box dialog_img">
        <img src="../assets/image/satisfy.png" />
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'FeedBack',
  components: {
    'set-as-high-intent-customer': () => import('@/pages/cloudClue/Components/SetAsHighIntentCustomer'),
  },
  props: {
    orderId: Number,  // 对应（order_id  mycompany_id  clue_id   uid）
    type: Number,  // 使用位置（订单，线索，公司， 客户）
    isShow: Boolean,  // 公司不显示客户意向
    cType: Number // 考核类型 id
  },
  data() {
    return {
      uploadHeader: { Authorization: localStorage.token },
      reflectForm: {
        index: null,
        content: '',
        contact_type: null,
        keyword_cate: null,
        keyword: [],
        is_notice: '0',
        next_contact_time: null,
        contact_duration: 0,
        satisfy: null,
        has_contacted: null,
        is_check_tax: null,
        is_add_wx: null
      },
      uploadedList: [],
      formData: null,
      childKeywords: [],
      chat_methods: [],
      reflects: [],
      keywordCates: [],
      order: [],
      order_id: null,
      dialogVisible3: false,
      che_type: null,
      nextPickerOptions: {
        shortcuts: [
          {
            text: '一天后',
            onClick: () => {
              const date = new Date()
              date.setDate(date.getDate() + 1)
              this.setDateTime(date)
            }
          },
          {
            text: '三天后',
            onClick: () => {
              const date = new Date()
              date.setDate(date.getDate() + 3)
              this.setDateTime(date)
            }
          },
          {
            text: '一周后',
            onClick: () => {
              const date = new Date()
              date.setDate(date.getDate() + 7)
              this.setDateTime(date)
            }
          },
          {
            text: '一个月后',
            onClick: () => {
              const date = new Date()
              date.setMonth(date.getMonth() + 1)
              this.setDateTime(date)
            }
          }
        ]
      },
      developText: false,
      develop: {
        reflect_id: null,
        content: ''
      },
      StrongIntentionCheckBox: false,
      aleadyHighIntentCustomer: false
    }
  },
  watch: {
    // orderId: function (val) {
    //     this.order_id = val || null
    //     this.formData = new FormData()
    //     if (val) {
    //       this.getOrderReflect()
    //     }
    // }
    orderId: {
      immediate: true,
      handler(val) {
        this.order_id = val || null
        this.formData = new FormData()
        if (val) {
          this.getOrderReflect()
        }
      }
    }
  },
  created() {
    this.order_id = this.orderId
  },
  methods: {
    developAdvice() {
      this.developText = true
    },
    developAdviceCancel() {
      this.developText = false
    },
    developAdviceSave(reflectId) {
      if (!this.develop.content) {
        this.$message.error('请填写开发建议！')
        return
      }
      this.develop.reflect_id = reflectId
      this.$axios.post('/api/admin/tyc_order_reflect/store', { develop: this.develop }).then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.$message.success('提交成功！')
          this.clearReflect()
          this.getOrderReflect()
        }
      })
    },
    getOrderReflect() {
      this.$axios.get('/api/admin/tycOrders/orderReflect/' + this.order_id + '/' + this.type + '/' + this.cType).then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.order = data.data.tycOrder
          this.reflects = data.data.reflects
          this.keywordCates = data.data.keywordCates
          this.chat_methods = data.data.chat_methods
          if (data.data.reflects.length && data.data.reflects[0].high_intent_customer_feedback) this.aleadyHighIntentCustomer = true
        }
      })
    },
    setDateTime(date) {
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);
      this.reflectForm.next_contact_time = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${hours}:${minutes}:${seconds}`;
    },
    handelKeywordCateChange() {
      this.reflectForm.keyword = []
      this.childKeywords = []
      // 根据分类获取关键词
      this.$axios.post('/api/admin/process/check/get_keyword_by_cate', {
        keyword_cate_id: this.reflectForm.keyword_cate
      })
        .then(({ data }) => {
          if (data.code === 0) {
            this.childKeywords = data.data.result
          }
        })
        .catch()
    },
    submitUpload() {
      if (!this.reflectForm.contact_type) {
        this.$message.error('请选择联系方式')
        return
      }

      if (!this.reflectForm.satisfy) {
        this.$message.error('请选择客户意向')
        return
      }

      if (!this.reflectForm.keyword_cate) {
        this.$message.error('请选择关键词分类')
        return
      }

      if (this.reflectForm.keyword.length <= 0) {
        this.$message.error('请选择关键词')
        return
      }

      if (!this.reflectForm.has_contacted) {
        this.$message.error('请选择是否与客户取得联系')
        return
      }

      if (
        this.reflectForm.contact_type === 1 &&
        !/(^[1-9]\d*$)/.test(this.reflectForm.contact_duration)
      ) {
        this.$message.error('请填写通话时长，必须为正整数')
        return
      }

      if (this.reflectForm.is_notice === '1' && !this.reflectForm.next_contact_time) {
        this.$message.error('请选择下次沟通的时间')
        return
      }

      if (!this.reflectForm.content) {
        this.$message.error('反馈内容不能为空')
        return
      }

      if (this.StrongIntentionCheckBox) {
        if (!this.$refs.setAsHighIntentCustomer.mean.cash) {
          this.$message.error('请填写意向金额!')
          return false
        } else {
          let reg = /^-?\d{1,100}(?:\.\d{1,4})?$/ // 小数点左边最高4位，小数点右边最多4位
          if (!reg.test(this.$refs.setAsHighIntentCustomer.mean.cash)) {
            this.$message.error('金额错误!')
            return false
          }
        }

      }

      this.uploadedList.forEach((file) =>
        this.formData.append('file[]', file.raw)
      )
      this.formData.append('contact_type', this.reflectForm.contact_type)
      this.formData.append('satisfy', this.reflectForm.satisfy)
      this.formData.append('has_contacted', this.reflectForm.has_contacted)
      this.formData.append('contact_duration', this.reflectForm.contact_duration)
      this.formData.append('reflect_content', this.reflectForm.content)
      this.formData.append('order_id', this.order_id)

      this.formData.append('keyword_cate', this.reflectForm.keyword_cate)
      this.formData.append('keyword', this.reflectForm.keyword)
      this.formData.append('is_notice', this.reflectForm.is_notice)
      this.formData.append('next_contact_time', this.reflectForm.next_contact_time)
      this.formData.append('type', this.type)
      this.formData.append('check_type', this.cType)
      this.formData.append('is_check_tax', this.reflectForm.is_check_tax)
      this.formData.append('is_add_wx', this.reflectForm.is_add_wx)
      this.formData.append('mean', this.$refs.setAsHighIntentCustomer ? JSON.stringify(this.$refs.setAsHighIntentCustomer.mean) : null)

      this.$axios
        .post('/api/upload/tyc/reflectImg', this.formData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$emit('reflectCompleted',this.orderId)
            this.getOrderReflect()
            this.clearReflect()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    clearReflect() {
      this.reflectForm.content = ''
      this.reflectForm.contact_type = null
      this.reflectForm.satisfy = null
      this.reflectForm.has_contacted = null
      this.reflectForm.is_check_tax = null
      this.reflectForm.contact_duration = 0
      this.reflectForm.keyword_cate = null
      this.reflectForm.keyword = []
      this.reflectForm.is_notice = '0'
      this.reflectForm.next_contact_time = null
      this.reflectForm.is_add_wx = null
      this.childKeywords = []
      this.keywordCates = []
      this.chat_methods = []
      this.uploadedList = []
      this.developText = false
      this.develop.content = ''
      this.develop.reflect_id = null
      this.formData = null
      this.formData = new FormData()
    },
    handleParse(e) {
      let file = null
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf('image') > -1
      ) {
        file = e.clipboardData.items[0].getAsFile()
        let reader = new FileReader()
        reader.readAsDataURL(file)
        let that = this
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: 'ready',
            url: e.target.result,
          }

          that.uploadedList.push(fileObj)
        }
      } else {
        this.$message.warning('上传的文件必须为图片')
      }
    },
    fileChange(file, fileList) {
      this.uploadedList = fileList
    },
    fileRemove(file, fileList) {
      this.uploadedList = fileList
    },
    handleReflectPreview(file) {
      let tempwindow = window.open('_blank')
      tempwindow.location = file.url
    },
  },
  mounted() {

  }
}
</script>

<style lang="stylus" scoped>
  .feed-back
    .count-style
      display: inherit
      overflow: hidden
      text-overflow: ellipsis
      white-space: nowrap
    .m-tab
      border-top: 1px solid #dee2e6
      border-left: 1px solid #dee2e6
    .m-th
      height: 42px
      line-height: 42px
      padding: 0 5px
      border-bottom: 1px solid #dee2e6
    .m-td
      height: 42px
      line-height: 42px
      padding: 0 5px
      border-left: 1px solid #dee2e6
      border-right: 1px solid #dee2e6
      border-bottom: 1px solid #dee2e6
    .mt-10
      margin-top: .2rem
    .mt-20
      margin-top: .4rem
    .tr
      text-align: right
    .el-card__body p
      margin-top: .4rem
    .el-dialog .el-select
      width: 100%
    .elRadioGroup >>> .el-radio-button .el-radio-button__inner
        border 1px solid #dcdfe6
        border-radius .08rem
        margin 0 .1rem .1rem 0
        box-sizing border-box
    .elRadioGroup >>> .el-radio-button__orig-radio:checked+.el-radio-button__inner
        box-shadow 0 0 transparent
  </style>


// WEBPACK FOOTER //
// src/common/FeedBack.vue